(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viciencia-quiz"] && !Shopify.designMode) return;
  try {
    
class VicienciaRoutineQuizV4 extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    this.steps = [...this.querySelectorAll('[data-question]')];
    this.cards = [...this.querySelectorAll('[data-product]')];
    if (this.steps.length < 3 || this.steps.length > 5 || this.steps.some(s => s.querySelectorAll('input').length < 2)) return;
    this.index = 0;
    this.screen('welcome', false);
    this.querySelector('.vq__start').hidden = false;
    const on = (selector,fn) => this.querySelector(selector).addEventListener('click',fn,{signal:this.abort.signal});
    on('[data-start]',()=>{this.screen('form');this.show();});
    on('[data-back]',()=>{if(this.index>0){this.index--;this.show();}else{this.screen('welcome');this.querySelector('[data-start]').focus({preventScroll:true});}});
    on('[data-restart]',()=>{this.querySelectorAll('input').forEach(i=>i.checked=false);this.index=0;this.screen('form');this.show();});
    const select = event => {
      const input=event.target;
      if(!input.matches('input[type="radio"]')||!input.checked||input.closest('[data-question]')!==this.steps[this.index])return;
      this.querySelector('.vq__error').hidden=true;
      clearTimeout(this.advanceTimer);
      this.advanceTimer=setTimeout(()=>this.advance(),200);
    };
    this.addEventListener('click',select,{signal:this.abort.signal});
    this.addEventListener('change',select,{signal:this.abort.signal});
  }
  disconnectedCallback(){this.abort?.abort();clearTimeout(this.advanceTimer);}
  advance(){
    clearTimeout(this.advanceTimer);
    if(this.querySelector('[data-form]').hidden)return;
    if(!this.steps[this.index].querySelector('input:checked')){this.querySelector('.vq__error').hidden=false;this.steps[this.index].querySelector('input').focus();return;}
    if(this.index<this.steps.length-1){this.index++;this.show();}else this.results();
  }
  screen(name, scroll = true){
    clearTimeout(this.advanceTimer);
    ['welcome','form','results'].forEach(key=>{
      const panel=this.querySelector(`[data-${key}]`);
      panel.hidden=key!==name;
      if(key!==name)panel.style.setProperty('display','none','important');
      else panel.style.removeProperty('display');
    });
    if(scroll)this.scrollIntoView({block:'start',behavior:'instant'});
  }
  show(){
    clearTimeout(this.advanceTimer);
    this.steps.forEach((s,i)=>s.hidden=i!==this.index);
    this.querySelector('.vq__error').hidden=true;
    this.querySelector('.vq__counter').textContent=`${this.index+1} / ${this.steps.length}`;
    this.querySelector('progress').value=this.index+1;
    this.steps[this.index].querySelector('legend').focus({preventScroll:true});
  }
  results(){
    const scores={};let iron=false;
    this.steps.forEach(s=>{const a=s.querySelector('input:checked');if(!a)return;const key=a.dataset.profile;if(key!=='none')scores[key]=(scores[key]||0)+Number(a.dataset.points||0);if(a.dataset.iron==='true')iron=true;});
    const seen=new Set();let count=0;
    this.cards.forEach(c=>{c.hidden=true;c.querySelector('[data-matched-reason]')?.removeAttribute('hidden');c.querySelector('[data-fallback-reason]').hidden=true;});
    const ranked=this.cards.map((c,i)=>({c,i,score:c.dataset.profile==='iron'&&!iron?0:(scores[c.dataset.profile]||0)})).sort((a,b)=>b.score-a.score||a.i-b.i);
    for(const {c,score} of ranked){if(score<=0||count>=Number(this.dataset.limit)||seen.has(c.dataset.product))continue;seen.add(c.dataset.product);c.hidden=false;this.querySelector('.vq__results-grid').append(c);count++;}
    const fallback = count === 0;
    if(fallback){
      const priorities={vitamins:5,omega:4,magnesium:3,stress:2,iron:0};
      const options=this.cards.filter(c=>c.dataset.profile!=='iron'||iron).map((c,i)=>({c,i,priority:c.dataset.fallbackPriority===''?priorities[c.dataset.profile]||0:Number(c.dataset.fallbackPriority)})).sort((a,b)=>b.priority-a.priority||(priorities[b.c.dataset.profile]||0)-(priorities[a.c.dataset.profile]||0)||a.i-b.i);
      for(const {c} of options){
        if(count>=Number(this.dataset.limit)||seen.has(c.dataset.product))continue;
        seen.add(c.dataset.product);c.hidden=false;c.querySelector('[data-matched-reason]')?.setAttribute('hidden','');c.querySelector('[data-fallback-reason]').hidden=false;this.querySelector('.vq__results-grid').append(c);count++;
      }
    }
    this.querySelector('[data-matched-intro]').hidden=fallback;
    this.querySelector('[data-fallback-intro]').hidden=!fallback;
    this.querySelector('[data-empty]').hidden=count>0;
    this.querySelector('.vq__results-grid').hidden=count===0;
    this.screen('results');this.querySelector('[data-results] h2').focus({preventScroll:true});
  }
}
if(!customElements.get('viciencia-routine-quiz-v4'))customElements.define('viciencia-routine-quiz-v4',VicienciaRoutineQuizV4);

  } catch(e) { console.error(e); }
})();
})();
